<template>
  category default vue template
  {{ category }}

  <div v-for="article in articlesPage.rows" :key="article.id">
    <div>{{ article.title }}</div>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import type { Article, Category, Tags, Page } from '~/types';
  import cmsUtils from '~/utils/cmsUtils'

  // 接收分类数据
  const props = withDefaults(defineProps<{
    category: Category | null
    tagsList?: Tags[]
    pageNum?: number
    pageSize?: number
  }>(), {
    tagsList: () => [],
    pageNum: 1,
    pageSize: 10
  })



  const cmsInfo = await cmsUtils.getCmsInfo();
  const childCategoryIds = cmsUtils.getChildCategoryIds(props.category!.id, cmsInfo);
  const allCategoryIds = [props.category!.id, ...childCategoryIds];
  const body = {
      "websiteId": cmsInfo!.website.id,
      "categoryIds": allCategoryIds,
      "tagsIds": props.tagsList.map(item => item.id)
  }
  const articlesPage = await useHttp("/nuxt/article/list", {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json'
      },
      body: body
  }) as Page<Article>;
</script>

<style scoped lang='scss'></style>
